module.exports = __webpack_public_path__ + "r-v3/img/plus_blue.b03562e8.svg";